document.addEventListener('DOMContentLoaded', () => {
    const columns = document.querySelectorAll('.site-footer__column');

    // Check if there are no footer columns.
    if (columns.length === 0) {
        return;
    }
  
    columns.forEach(column => {
        const headings = column.querySelectorAll('.site-footer__column__heading');

        // Check if there are no headings in this column.
        if (headings.length === 0) {
        return;
        }
  
        headings.forEach(heading => {
            heading.addEventListener('click', () => {
                // Only run accordion logic on mobile
                if (window.innerWidth < 768) {
                const navigation = heading.parentElement.querySelector('.site-footer__column__navigation');
                const icon = heading.querySelector('.site-footer__column__heading__icon');

                // If no navigation list found, exit early
                if (!navigation) return;

                const isOpen = !navigation.classList.contains('hidden');

                // Close all other navigation menus
                const allNavigations = document.querySelectorAll('.site-footer__column__navigation');
                const allIcons = document.querySelectorAll('.site-footer__column__heading__icon');

                allNavigations.forEach(otherNav => {
                    if (otherNav !== navigation && !otherNav.classList.contains('hidden')) {
                    // Collapse other navs with animation
                    otherNav.style.height = otherNav.scrollHeight + 'px';
                    void otherNav.offsetHeight;
                    otherNav.style.height = '0px';

                    otherNav.addEventListener('transitionend', function handler() {
                        otherNav.classList.add('hidden');
                        otherNav.style.height = '';
                        otherNav.removeEventListener('transitionend', handler);
                    }, { once: true });
                    }
                });

                // Reset all other icons
                allIcons.forEach(otherIcon => {
                    if (otherIcon !== icon) {
                    otherIcon.classList.remove('rotate-180');
                    }
                });

                if (!isOpen) {
                    // Expand the clicked section
                    navigation.classList.remove('hidden');
                    navigation.style.height = '0px';
                    void navigation.offsetHeight;
                    navigation.style.height = navigation.scrollHeight + 'px';

                    navigation.addEventListener('transitionend', function handler() {
                    navigation.style.height = '';
                    navigation.removeEventListener('transitionend', handler);
                    }, { once: true });

                    icon?.classList.add('rotate-180');

                } else {
                    // Collapse the clicked section
                    navigation.style.height = navigation.scrollHeight + 'px';
                    void navigation.offsetHeight;
                    navigation.style.height = '0px';

                    navigation.addEventListener('transitionend', function handler() {
                    navigation.classList.add('hidden');
                    navigation.style.height = '';
                    navigation.removeEventListener('transitionend', handler);
                    }, { once: true });

                    icon?.classList.remove('rotate-180');
                }
                }
            });
        });
    });
  });